import type { VideoResolver } from '../types';

export const resolveHtmlVideo: VideoResolver = ({ src, ...attrs }) => {
  if (typeof src === 'undefined') {
    return undefined;
  }

  return {
    video: {
      src,
      muted: attrs.autoPlay === true ? true : attrs.muted,
    },
  };
};
